module.exports = __webpack_public_path__ + "static/media/detail_0006_t.14cee73d.jpg";